import React from 'react';
import { Eye, Palette, ImageIcon, CheckSquare } from 'lucide-react';

export const TopToolbar = ({ tools, tool, setTool, canEdit, setIsLibraryOpen, onAddImageClick, isPreview, onTogglePreview, canManageProject, historyButtons, saveStatus, currentUser, showConfirmations, onToggleConfirmations }) => {
    return (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 z-30 hidden md:flex items-center">
            <div className="bg-white rounded-lg shadow-md border border-slate-200 dark:border-gray-700 dark:bg-gray-800 p-1 flex items-center space-x-1">
                {tools.map((t) => (
                    <button
                        key={t.id}
                        disabled={!canEdit && t.id !== 'select'}
                        onClick={() => {
                            if (!canEdit && t.id !== 'select') return;
                            setTool(t.id);
                        }}
                        className={`p-2 rounded-md transition-colors ${
                            tool === t.id 
                            ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-400' 
                            : 'text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700'
                        } disabled:opacity-50 disabled:cursor-not-allowed`}
                        title={t.label}
                    >
                        <t.icon className="w-5 h-5" />
                    </button>
                ))}
                <div className="h-6 w-px bg-slate-200 dark:bg-gray-600 mx-1"></div>
                {canEdit && (
                    <>
                        <button
                            onClick={onAddImageClick}
                            className="p-2 rounded-md transition-colors text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700"
                            title="Add Decorative Image"
                        >
                            <ImageIcon className="w-5 h-5" />
                        </button>
                        <button
                            onClick={() => setIsLibraryOpen(true)}
                            className="p-2 rounded-md transition-colors text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700"
                            title="Open Library"
                        >
                            <Palette className="w-5 h-5" />
                        </button>
                    </>
                )}
                {currentUser && currentUser.role !== 'customer' && (
                    <button
                        onClick={() => onTogglePreview(!isPreview)}
                        className={`p-2 rounded-md transition-colors ${isPreview ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-400' : 'text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700'}`}
                        title={isPreview ? 'Exit Preview' : 'Preview Mode'}
                    >
                        <Eye className="w-5 h-5" />
                    </button>
                )}

                 <button
                    onClick={() => onToggleConfirmations(!showConfirmations)}
                    className={`p-2 rounded-md transition-colors ${showConfirmations ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/50 dark:text-blue-400' : 'text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700'}`}
                    title={showConfirmations ? 'Hide Confirmations' : 'Show Confirmations'}
                >
                    <CheckSquare className="w-5 h-5" />
                </button>

                {canManageProject && historyButtons}
            </div>
            {saveStatus && (
                <div className="ml-4 text-xs font-semibold text-gray-500 dark:text-gray-400 transition-opacity duration-300">
                    {saveStatus}
                </div>
            )}
        </div>
    );
};
